<i18n>
{
	"en": {
		"order": "Order",
		"theOrder": "the order",
		"mainTabName": "Main order",
		"newOrder": "New order",
		"save": "Save",
		"unableToFindOrder": "Could not find order",
		"failedToSave": "Failed to save order",
		"openTmsR10": "Open order in TMS R10",
		"openTmsR10Success": "Request has been sent to TMS R10!",
		"openTmsR10Error": "Failed sending request to TMS R10. Error message: ",
		"orderSaved": "The order was saved",
		"cancelLabel": "Cancel",
		"packageLabel": "Labels",
		"waybill": "Waybill",
		"saveAndClose": "Save & close",
		"unabledToCopyOrder": "Could not copy the order",
		"copyOrder": "Copy Order",
		"orderCopied": "Order successfully copied",
		"validationErrors": "Failed to save order due to validation errors",
		"unableToUpdateOrder": "Could not update order",
		"orderChangelog": "Changelog",
		"unableToFetchChangelog": "Failed to fetch order changelog",
		"parallelSubOrderCreated": "Parallel created",
		"unableToCreateParallelSubOrder": "Unable to create parallel",
		"ediName": "EDI from {name}"
	},
	"no": {
		"order": "Oppdrag",
		"theOrder": "oppdraget",
		"mainTabName": "Hovedoppdrag",
		"newOrder": "Nytt oppdrag",
		"save": "Lagre",
		"unableToFindOrder": "Kunne ikke finne oppdrag",
		"failedToSave": "Kunne ikke lagre oppdrag",
		"openTmsR10": "Åpne ordre i TMS R10",
		"openTmsR10Success": "En spørring har blitt sendt til TMS R10",
		"openTmsR10Error": "Spørringen mot TMS R10 feilet med melding: ",
		"orderSaved": "Oppdraget ble lagret",
		"cancelLabel": "Avbryt",
		"packageLabel": "Etiketter",
		"waybill": "Fraktbrev",
		"saveAndClose": "Lagre & lukk",
		"unabledToCopyOrder": "Kunne ikke kopiere oppdrag",
		"copyOrder": "Kopier oppdrag",
		"orderCopied": "Oppdrag kopiert",
		"validationErrors": "Kunne ikke lagre oppdrag på grunn av valideringsfeil",
		"unableToUpdateOrder": "Kunne ikke oppdatere oppdrag",
		"orderChangelog": "Endringer",
		"unableToFetchChangelog": "Kunne ikke hente endringsloggen",
		"parallelSubOrderCreated": "Parallell strekning laget",
		"unableToCreateParallelSubOrder": "Kunne ikke lage parallel strekning",
		"ediName": "EDI fra {name}"
	}
}
</i18n>

<template>
	<t-dialog
		large
		:hasHeader="false"
		:isShown="isShown"
		:icon="isNewOrder ? 'order-new' : 'order'"
		disableCloseOnConfirm
		alwaysRememberFocus
		:hasCancel="false"
		:hasConfirm="false"
		:keyListeners="getKeyListeners()"

		paddingModalBody="16px 16px 16px 6px"

		@closing="checkClose"
		@close="onClose"
	>
		<t-horizontal-panel
			:showRightPanel="editJsonVisible"
		>
			<template v-slot:left>

				<div>
					<div class="main-header">
						<t-timpex-icon
							:icon="isNewOrder ? 'order-new' : 'order'"
							:color="'neutral'"
							class="header-icon"
						/>
						<div class="title">
							<div style="margin-bottom: 4px;">
								{{ isNewOrder ? $t('newOrder') : $t('order') + ' ' + order.orderNumber }}
							</div>

							<a
								v-if="order.waybillNumber && timpexServerURL === null"
								class="waybill-number"
							>
								{{ order.waybillNumber }}
							</a>
							<a
								v-else-if="order.waybillNumber && timpexServerURL !== null"
								class="waybill-number"
								:href="`${timpexServerURL}/Js/timpex.js.traffic.trace.client.v2/index.html?traceNo=${order.waybillNumber}`"
								target="_blank"
							>
								{{ order.waybillNumber }}
							</a>
							<div v-if="order.registeredDate && order.registeredDate.date" class="registeredDate">
								{{ registeredDateString }}
							</div>
							<div v-if="order.edi && order.edi.in_edipartId" class="ediName">
								{{ $t('ediName', {name: ediName}) }}
							</div>
						</div>

					</div>

					<hr style="margin-top: 5px; margin-bottom: 8px;" >

					<SubOrdersMain
						@createParallelSuborder="onCreateParallelSubOrder"
						@selected="setSelectedSubOrderByIndex"
					/>
				</div>
			</template>

			<template>

				<div ref="focusBase" style="margin: 0 0 0 8px; width: 1313px; height:100%; display:flex; flex-direction: column">

					<div style="margin-top: 2px">
						<t-tab
							:value="$t('mainTabName')"
							:selected="currentOrderTabIndex === mainOrderTabIndex"
							disableTabbing
							:isInvalid="errors.order.isInvalid"
							@selected="setSelectedSubOrderByIndex(mainOrderTabIndex)"
						>
							<template v-if="isTimpexSupport" v-slot:contextMenu>
								<t-menu>
									<t-menu-group>
										<t-menu-item @click="toggleEditJson"><strong>JSON</strong></t-menu-item>
									</t-menu-group>
								</t-menu>
							</template>
						</t-tab>
						<SubOrderMenu
							:subOrderTabs="subOrderTabs"
							@selectSubOrder="setSelectedSubOrderByIndex"
						/>

						<hr style="margin-top: 5px; margin-bottom: 16px;" >
					</div>

					<div style="flex:1">
						<MainOrderContent
							v-show="currentOrderTabIndex === mainOrderTabIndex"
							:isNewOrder="isNewOrder"
							:currentDetailTabId="currentDetailTabId"
							:orderHasTrip="orderTypeHasTrip"

							@setSelectedDetailsTab="currentDetailTabId = $event"
							@detailsMainMounted="detailTabIds = $event.detailTabIds"
						/>

						<SubOrderContent
							v-show="currentOrderTabIndex !== mainOrderTabIndex"
							:isNewOrder="isNewOrder"
							:currentDetailTabId="currentDetailTabId"
							:orderHasTrip="orderTypeHasTrip"

							@setSelectedDetailsTab="currentDetailTabId = $event"
						/>
					</div>
				</div>
			</template>

			<template v-slot:right>
				<EditOrderJson
					v-show="editJsonVisible"
					:orderId="jsonObjectId"
					style="width: 600px;"
					@hide="hideEditJson"
					@changed="orderJsonChanged"
				/>
			</template>

		</t-horizontal-panel>
		<template #footer>
			<div style="width: 100%; display: flex; justify-content: space-between">
				<div style="display: flex">
					<t-button
						:value="$t('openTmsR10')"
						appearance="primary"
						type="bp"
						iconBefore="globe"
						tabindex="-1"
						@click="openOrderInTmsR10"
					/>
					<t-button
						v-if="!isNewOrder"
						:value="$t('packageLabel')"
						style="margin-left: 15px;"
						:appearance="order.hasOpenedPackageLabels ? 'primary' : 'default'"
						:intent="order.hasOpenedPackageLabels ? 'success' : null"
						type="timpex"
						iconBefore="package-label"
						tabindex="-1"
						@click="onOpenPackageLabel"
					/>
					<t-button
						v-if="!isNewOrder"
						:value="$t('waybill')"
						style="margin-left: 15px;"
						appearance="default"
						type="timpex"
						iconBefore="waybill"
						tabindex="-1"
						@click="onGetWaybill"
					/>
					<t-button
						v-if="!isNewOrder"
						:value="$t('copyOrder')"
						style="margin-left: 15px;"
						appearance="primary"
						type="bp"
						iconBefore="duplicate"
						tabindex="-1"
						@click="toggleCopyOrderPrompt(true)"
					/>
					<SendSubOrderToConfirmButton
						:disabled="isNewOrder || selectedSubOrder === undefined"
						:subOrder="selectedSubOrder"
					/>

					<t-button
						v-if="!isNewOrder"
						:value="$t('orderChangelog')"
						style="margin-left: 15px;"
						appearance="primary"
						type="bp"
						iconBefore="history"
						tabindex="-1"
						@click="toggleOrderChangelog(true)"
					/>

				</div>

				<div style="display: flex">
					<t-button
						:value="$t('cancelLabel')"
						type="bp"
						appearance="default"
						tabindex="-1"
						@click="onCancel"
					/>
					<t-button
						:value="$t('saveAndClose')"
						:busy="savePending"
						style="margin-left: 15px;"
						appearance="primary"
						type="bp"
						tabindex="-1"
						:disabled="orderIsLocked"

						@click="onSaveAndCloseOrder"
					/>
					<t-button
						:value="$t('save')"
						:busy="savePending"
						style="margin-left: 15px;"
						appearance="primary"
						type="bp"
						tabindex="-1"
						:disabled="orderIsLocked"

						@click="onSaveOrder"
					/>
				</div>
			</div>
		</template>
		<ConfirmUnsavedChanges
			:isShown="confirmUnsavedChanges"
			:subject="$t('theOrder')"
			@cancel="toggleUnsavedChanges(false)"
			@save="onSaveAndCloseOrder"
			@close="onCloseDirty"
		/>
		<CopyOrderSettings
			:isShown="copyOrderVisible"
			:etd="order.etd"
			@close="toggleCopyOrderPrompt(false)"
			@save="onCopyOrder"
		/>
		<OrderChangelog
			:isShown="orderChangelogVisible"
			:changelog="changelog"
			:subOrderTabs="subOrderTabs"
			@close="toggleOrderChangelog(false)"
		/>
		<MissingSyncRequirements
			:isShown="missingSyncRequirementsVisible"
			:invalidList="invalidSyncList"
			@close="toggleMissingSyncRequirements(false)"
		/>
	</t-dialog>
</template>

<script>
import { delay, eventBus, storageDateFormat } from '@/core';
import { mapState, mapActions, mapMutations, mapGetters } from './store/newOrder.store.js';
import { mapGetters as mapLoginGetters } from '../login/store/login.store';
import { mapState as mapSettingsState, mapActions as mapSettingsActions } from '../settings/store/settings.store';
import SubOrdersMain from '@/modules/newOrder/subOrders/SubOrdersMain';
import SubOrderContent from '@/modules/newOrder/subOrders/SubOrderContent';
import MainOrderContent from '@/modules/newOrder/MainOrderContent';
import SendSubOrderToConfirmButton from '@/modules/sendSubOrderToConfirm/SendSubOrderToConfirmButton';
import ConfirmUnsavedChanges from '@/components/modals/ConfirmUnsavedChanges';
import CopyOrderSettings from './modals/CopyOrderSettings';
import OrderChangelog from './modals/OrderChangelog';
import MissingSyncRequirements from './modals/MissingSyncRequirements';
import SubOrderMenu from '@/modules/newOrder/SubOrderMenu';
import moment from 'moment';

import EditOrderJson from '@/modules/editOrderJson/EditOrderJson.vue';
import TDialog from '@/components/evergreen/overlays/TDialog';
import TTab from '@/components/evergreen/tabs/TTab';
import TMenu from '@/components/evergreen/menu/TMenu';
import TMenuGroup from '@/components/evergreen/menu/TMenuGroup';
import TMenuItem from '@/components/evergreen/menu/TMenuItem';
import THorizontalPanel from '@/components/evergreen/timpex/layers/THorizontalPanel';
import TTimpexIcon from '@/components/evergreen/timpex/icons/TTimpexIcon';
import TButton from '@/components/evergreen/buttons/TButton';

export default {
	name: 'newOrder',
	components: {
		TButton,
		TTimpexIcon,
		THorizontalPanel,
		TMenuItem,
		TMenuGroup,
		TMenu,
		TTab,
		TDialog,
		MainOrderContent,
		SubOrderContent,
		SubOrdersMain,
		ConfirmUnsavedChanges,
		CopyOrderSettings,
		SendSubOrderToConfirmButton,
		EditOrderJson,
		OrderChangelog,
		MissingSyncRequirements,
		SubOrderMenu
	},
	data() {
		return {
			isShown: false,
			currentDetailTabId: 'freightLines',
			confirmUnsavedChanges: false,
			closeDirty: false,
			copyOrderVisible: false,
			savePending: false,
			detailTabIds: [],
			editJsonVisible: false,
			orderChangelogVisible: false,
			missingSyncRequirementsVisible: false,
			invalidSyncList: [],
		};
	},
	computed: {
		...mapState([
			'order',
			'subOrders',
			'errors',
			'dirty',
			'selectedSubOrder',
			'mainOrderTabIndex',
			'currentOrderTabIndex',
			'changelog',
			'ediName'
		]),
		...mapGetters(['subOrderTabs', 'orderIsLocked','orderTypeHasTrip']),
		...mapLoginGetters(['isTimpexSupport']),
		...mapSettingsState(['allAvailableSettings']),
		isNewOrder() { // Can be a new order or an edit of existing order
			return !this.order || !this.order.id;
		},
		registeredDateString() {
			if (this.isNewOrder)
				return '...';
			if (this.order.registeredDate) {
				return moment(this.order.registeredDate.date, storageDateFormat).format('DD.MM.YYYY HH:mm');
			}
			return '';
		},
		jsonObjectId() {
			return this.order.id;
		},
		timpexServerURL() {
			let timpexServerURLSetting = this.allAvailableSettings.find(
				x => x.id === 'Timpex.Server'
			);

			if (timpexServerURLSetting === undefined)
				return null;

			else
				return timpexServerURLSetting.value;
		}
	},
	async created() {
		if (this.isNewOrder) {
			await this.cleanState();
		}
		eventBus.$on('toggleNewOrderModal', this.toggleNewOrderModal);
		eventBus.$on('setEditOrder', this.onSetEditOrder);
		eventBus.listenToQueue('setEditOrderByQuickSearch', this.onSetEditOrderByQuickSearch);

		this.getSettings();
	},
	beforeDestroy() {
		eventBus.$off('toggleNewOrderModal', this.toggleNewOrderModal);
		eventBus.$off('setEditOrder', this.onSetEditOrder);
		eventBus.removeQueueListener('setEditOrderByQuickSearch', this.onSetEditOrderByQuickSearch);
	},

	methods: {
		...mapActions([
			'saveNewOrder',
			'saveOrder',
			'cleanState',
			'setEditOrder',
			'setEditOrderByQuickSearch',
			'openTmsR10',
			'getWaybill',
			'getPackageLabel',
			'copyOrder',
			'setSelectedSubOrder',
			'fetchOrderChangelog',
			'createParallelSubOrder',
			'getOrderTypes',
		]),
		...mapMutations([ 'setValue', 'setDate', 'setCurrentOrderTabIndex', 'setHasOpenedPackageLabels' ]),
		...mapSettingsActions([ 'getSettings' ]),

		setSelectedSubOrderByIndex(orderTabIndex) {
			this.setCurrentOrderTabIndex(orderTabIndex);
			let subOrderTab = this.subOrderTabs.find(x => x.index === orderTabIndex);
			if (subOrderTab) {
				this.setSelectedSubOrder(subOrderTab.id);
			} else {
				this.setSelectedSubOrder(undefined);
			}

		},
		toggleNewOrderModal(value) {
			if (value) this.getOrderTypes();
			this.isShown = value;
		},
		toggleUnsavedChanges(value) {
			this.confirmUnsavedChanges = value;
		},
		onCancel() {
			if (this.dirty && !this.closeDirty) {
				this.toggleUnsavedChanges(true);
				this.closeDirty = false;
			} else {
				this.onClose();
			}
		},
		checkClose(abort) {
			if (this.dirty && !this.closeDirty) {
				if (abort instanceof Function) abort(true);
				this.toggleUnsavedChanges(true);
			} else {
				abort(false);
			}
			this.closeDirty = false;
		},
		onCloseDirty() {
			this.closeDirty = true;
			this.onClose();
		},
		onClose() {
			this.toggleUnsavedChanges(false);
			this.setCurrentOrderTabIndex(this.mainOrderTabIndex);
			this.cleanState();
			this.$notify({ clean: true });
			this.hideEditJson();
			this.isShown = false;
		},
		async onSaveOrder() {
			this.$notify({
				clean: true,
			});
			try {
				this.savePending = true;
				await this.saveCore();
				this.savePending = false;
				this.$notify({
					type: 'success',
					title: this.$t('orderSaved')
				});
				eventBus.$emit('loadPlanningOrderSearch');
				return true;
			} catch (e) {
				this.savePending = false;
				this.$notify({
					type: 'error',
					title: this.$t(e.message || 'failedToSave'),
					duration: -1
				});
				return false;
			}
		},
		async onSaveAndCloseOrder() {

			if (await this.onSaveOrder())
				this.onClose();
		},
		async saveCore() {
			this.toggleUnsavedChanges(false);

			if (this.isNewOrder) {
				await this.saveNewOrder();
			} else {
				await this.saveOrder();
			}
			eventBus.$emit('refreshOrderList');
		},
		async openOrderInTmsR10() {
			try {
				await this.saveCore();
				await delay(1500);
				await this.openTmsR10(this.order);
				this.$notify({
					type: 'success',
					title: this.$t('openTmsR10Success'),
				});
			} catch (err) {
				if (err.message === 'notSyncable') {
					this.invalidSyncList = err.invalidList;
					this.toggleMissingSyncRequirements(true);
				} else {
					this.$notify({
						type: 'error',
						title: `${this.$t('openTmsR10Error')}${err.message}`,
					});
				}
			}
		},
		async onSetEditOrder(id) {
			try {
				await this.setEditOrder(id);
				this.toggleNewOrderModal(true);
				this.fetchChangelog();
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('unableToFindOrder'),
					duration: -1
				});
			}
		},
		async onSetEditOrderByQuickSearch(orderNumber) {
			try {
				await this.setEditOrderByQuickSearch(orderNumber);
				this.toggleNewOrderModal(true);
				this.fetchChangelog();
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('unableToFindOrder'),
					duration: -1
				});
			}
		},
		async fetchChangelog() {
			try {
				await this.fetchOrderChangelog();
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('unableToFetchChangelog'),
					duration: -1
				});
			}
		},
		toggleCopyOrderPrompt(value) {
			this.copyOrderVisible = value;
		},
		async onCopyOrder({ newEtd, count }) {
			this.$notify({ clean: true });
			try {
				await this.copyOrder({ newEtd, count });
				this.toggleCopyOrderPrompt(false);
				this.$notify({
					type: 'success',
					title: this.$t('orderCopied'),
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('unabledToCopyOrder'),
					duration: -1
				});
			}
		},
		hideEditJson() {
			this.editJsonVisible = false;
		},
		toggleEditJson() {
			this.editJsonVisible = !this.editJsonVisible;
		},
		orderJsonChanged() {
			this.setEditOrder(this.order.id);
		},
		toggleOrderChangelog(value) {
			this.orderChangelogVisible = value;
		},
		toggleMissingSyncRequirements(value) {
			this.missingSyncRequirementsVisible = value;
		},
		async onCreateParallelSubOrder(subOrderId) {
			try {
				await this.createParallelSubOrder(subOrderId);
				this.$notify({
					type: 'success',
					title: this.$t('parallelSubOrderCreated'),
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('unableToCreateParallelSubOrder'),
					duration: -1
				});
			}
		},
		

		getKeyListeners() {
			return [
				{ 	key: 'F2',
					listener: this.onF2,
					modifiers: { shiftKey: undefined, ctrlKey: false, altKey: false, stop: true, prevent: true } },
				{ 	key: 'F3',
					listener: this.onF3,
					modifiers: { shiftKey: undefined, ctrlKey: false, altKey: false, stop: true, prevent: true } },
				{ 	key: 'S',
					listener: this.onSaveOrder,
					modifiers: { ctrlKey: true, shiftKey: undefined, altKey: false, stop: true, prevent: true } },
				{ 	key: 'Enter',
					listener: this.onSaveAndCloseOrder,
					modifiers: { ctrlKey: true, shiftKey: false, altKey: false, stop: true, prevent: true } },
			];
		},

		onF2(event) {
			let currentDetailTabIdIndex = this.detailTabIds.indexOf(this.currentDetailTabId);
			let nextIndex;
			if (event.shiftKey) {
				nextIndex = currentDetailTabIdIndex === 0 ?
					this.detailTabIds.length -1 :
					currentDetailTabIdIndex - 1;
			} else {
				nextIndex = currentDetailTabIdIndex === this.detailTabIds.length -1 ?
					0 :
					currentDetailTabIdIndex + 1;
			}
			this.currentDetailTabId = this.detailTabIds[nextIndex];
		},

		onF3(event) {
			let nextIndex;
			if (event.shiftKey) {
				nextIndex = this.currentOrderTabIndex === -1 ?
					this.subOrderTabs.length - 1 :
					Number(this.currentOrderTabIndex) - 1;
			} else {
				nextIndex = this.currentOrderTabIndex === this.subOrderTabs.length - 1 ?
					this.mainOrderTabIndex :
					Number(this.currentOrderTabIndex) + 1;
			}
			this.setSelectedSubOrderByIndex(nextIndex);
		},
		async onOpenPackageLabel() {

			this.setHasOpenedPackageLabels(true);

			if (this.dirty) {
				if (await this.onSaveOrder())
					this.getPackageLabel(this.order.id);

			} else {
				this.getPackageLabel(this.order.id);
			}
		},
		async onGetWaybill() {

			if (this.dirty) {
				if (await this.onSaveOrder())
					this.getWaybill(this.order.id);

			} else {
				this.getWaybill(this.order.id);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';


.main-header {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	margin-bottom: 9px;
	padding-left: 10px;
}

.header-icon {
	margin-top: 4px;
	margin-right: 10px;
}
.title {
	@extend %font-families-ui;
	@extend %text-large;
	color: get-color($text, 'dark');
	font-weight: 500;
	margin-bottom: 0;
	margin-top: 0;
	margin-right: 2px;
}

.waybill-number {
	@extend %font-families-mono;
	@extend %text-small;

	display: block;
	color: get-color($text, 'muted');
	letter-spacing: 1.2px;
}
.registeredDate {
	@extend %text-small;
}
.ediName {
	@extend %text-small;
	font-weight: bold;
}

hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
}

.additional-buttons-grid{
	display:grid;
	grid-auto-columns: 1fr;
	width:100%;
}

/deep/ .horizontal-panel-content {
	overflow-x:auto;
}
</style>
